<template>
  <el-dialog
    v-if="dialogVisible"
    title="三方租赁合同关闭提示"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="cancelHandler"
    append-to-body
  >
    <div class="container">
      <!-- 已关闭状态 -->
      <template v-if="currentStatus == '05'">
        <span>该合同已关闭,是否复制该合同进行后续操作</span>
      </template>
      <!-- 未关闭状态 -->
      <template v-else>
        <template v-if="isCreate && !isPaid">
          <div>该合同未完成结算，无法关闭</div>
          <div>请先关闭后续单据，再进行操作</div>
        </template>
        <span v-if="isCreate && isPaid">该合同已经完成结算,是否关闭</span>
        <!-- <template v-if="currentStatus == 1">
        <div>该合同已经完成结算,是否关闭</div>
        <div>请先关闭后续单据,再进行操作</div>
      </template> -->
        <template v-if="!isCreate">
          <span>该合同未创建结算，是否关闭</span>
        </template>
      </template>
    </div>
    <div class="btn-group">
      <IELUploadBtn @upload="uploadHandler" v-if="isCreate && isPaid" text="上传附件" />
      <el-button v-if="currentStatus == '03'" @click="confirmCloseHandler">仍然关闭</el-button>
      <el-button @click="confirmHandler" v-if="['07'].includes(currentStatus)">确 认</el-button>
      <el-button @click="copyContractHandler" v-if="currentStatus == '05'">复制合同</el-button>
      <el-button @click="cancelHandler" type="primary">取 消</el-button>
    </div>
    <ConfirmCloseDialog ref="confirmCloseDialogRef" @closeDialog="closeDialogHandler" />
  </el-dialog>
</template>

<script>
  import leaseContractApi from '@/api/park/leaseContract';
  import ConfirmCloseDialog from './components/ConfirmCloseDialog.vue';
  export default {
    name: 'CloseContractDialog',
    data() {
      return {
        dialogVisible: false,
        currentStatus: -1,
        currentContractId: -1,
        attachments: [], // 上传附件
        isCreate: '',
        isPaid: '',
      };
    },
    methods: {
      openDialog(currentContractId = -1, contractStatus = -1, isCreate, isPaid) {
        this.currentContractId = currentContractId;
        this.currentStatus = contractStatus;
        this.isCreate = isCreate;
        this.isPaid = isPaid;
        this.dialogVisible = true;
      },
      cancelHandler() {
        this.dialogVisible = false;
      },
      // 确认关闭
      async confirmHandler() {
        const { data } = await this.$axios.post(`${leaseContractApi.CLOSE_CONTRACT_BY_ID}`, {
          id: +this.currentContractId,
          attachments: this.attachments,
        });
        if (data.code == 0) {
          this.$message.success(data.msg);
          this.cancelHandler();
          this.$router.push('/park/leaseContract/leaseList');
          this.$emit('refreshTable');
        } else {
          this.$message.error(data.msg);
        }
      },
      // 仍然关闭
      confirmCloseHandler() {
        this.$refs.confirmCloseDialogRef.openDialog(this.currentContractId);
      },
      // 上传文件回调
      uploadHandler(fileObj) {
        this.attachments.push({
          attachmentName: fileObj.attachmentName,
          createBy: fileObj.createBy,
          gmtCreate: new Date(),
          attachmentKey: fileObj.attachmentKey,
          // attachmentId: fileObj.attachmentId,
          attachmentPath: fileObj.attachmentPath,
        });
      },
      // 复制合同
      copyContractHandler() {
        // const rowData = this.selectionList[0];
        // const { id, contractNo } = rowData || { contractNo: '', id: '' };
        const id = this.currentContractId;
        const path = {
          path: `/park/leaseContract/leaseDetail`,
          name: 'leaseDetail',
          meta: {
            keepAlive: false,
            title: '三方仓库租赁合同维护',
          },
          query: {
            status: 'create',
            id,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 关闭弹框
      closeDialogHandler() {
        this.cancelHandler();
        this.$emit('refreshTable');
      },
    },
    components: {
      ConfirmCloseDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    text-align: center;
  }
  .btn-group {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 30px;
  }
</style>
